import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase'; 
import { collection, addDoc, serverTimestamp, writeBatch, doc } from 'firebase/firestore';
import CurrencyInput from '../components/CurrencyInput'; 
import { logIslem } from '../utils/logger'; 

// Yardımcı: Para formatla
function formatCurrency(number) {
    if (typeof number !== 'number') return '0,00 ₺';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
}

function YeniCari() {
  const navigate = useNavigate();
  
  const [cariTipi, setCariTipi] = useState('Müşteri'); 
  const [kisiTuru, setKisiTuru] = useState('Sahis');   

  const [firmaSahis, setFirmaSahis] = useState('');
  const [tc, setTc] = useState('');
  const [adSoyad, setAdSoyad] = useState('');
  const [telefon, setTelefon] = useState('');
  const [adres, setAdres] = useState(''); 
  
  const [toplamBorc, setToplamBorc] = useState(''); 
  const [taksitSayisi, setTaksitSayisi] = useState('0'); 
  
  const [pesinat, setPesinat] = useState('');           
  const [pesinatOdenmis, setPesinatOdenmis] = useState(true); 
  const [vadeAraligi, setVadeAraligi] = useState('1'); 

  const [satisTarihi, setSatisTarihi] = useState(new Date().toISOString().split('T')[0]); 

  // --- YENİ: PLANLAMA TÜRÜ VE MANUEL LİSTE ---
  const [planTuru, setPlanTuru] = useState('otomatik'); // 'otomatik' veya 'manuel'
  const [manuelPlan, setManuelPlan] = useState([]); // [{tarih: '', tutar: 0}, ...]

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const taksitOptions = Array.from({ length: 60 }, (_, i) => i + 1);

  // --- MANUEL PLAN OLUŞTURUCU ---
  const planTaslagiOlustur = () => {
      const borcNum = parseFloat(toplamBorc) || 0;
      const pesinatNum = parseFloat(pesinat) || 0;
      const sayi = parseInt(taksitSayisi, 10);
      const aralik = parseInt(vadeAraligi, 10);

      const kalanTutar = borcNum - pesinatNum;

      if (kalanTutar <= 0 || sayi <= 0) {
          alert("Lütfen geçerli bir borç ve taksit sayısı girin.");
          return;
      }

      const yeniPlan = [];
      const ortalamaTutar = kalanTutar / sayi;
      const baslangic = new Date(satisTarihi);

      for (let i = 1; i <= sayi; i++) {
          const vadeTarihi = new Date(baslangic);
          vadeTarihi.setMonth(baslangic.getMonth() + (i * aralik));
          
          yeniPlan.push({
              id: i,
              tarih: vadeTarihi.toISOString().split('T')[0],
              tutar: ortalamaTutar
          });
      }
      setManuelPlan(yeniPlan);
  };

  const updateManuelSatir = (index, field, value) => {
      const yeniListe = [...manuelPlan];
      yeniListe[index][field] = value;
      setManuelPlan(yeniListe);
  };

  const hesaplananManuelToplam = manuelPlan.reduce((acc, item) => acc + (parseFloat(item.tutar) || 0), 0);
  const hedefTaksitToplami = (parseFloat(toplamBorc) || 0) - (parseFloat(pesinat) || 0);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (kisiTuru === 'Sahis' && !adSoyad) { setError('Ad Soyad gerekli.'); setLoading(false); return; }
    if (kisiTuru === 'Firma' && !firmaSahis) { setError('Firma Ünvanı gerekli.'); setLoading(false); return; }
    if (!telefon) { setError('Telefon gerekli.'); setLoading(false); return; }

    try {
      const carilerCollectionRef = collection(db, 'cariler');
      const newCariRef = await addDoc(carilerCollectionRef, {
        cariTipi, kisiTuru,
        firmaSahis: kisiTuru === 'Firma' ? firmaSahis : '', 
        tc, adSoyad, telefon, adres,
        createdAt: serverTimestamp()
      });
      
      const cariId = newCariRef.id;
      const taksitNum = parseInt(taksitSayisi, 10);
      const borcNum = parseFloat(toplamBorc);
      const pesinatNum = parseFloat(pesinat) || 0;
      const aralikNum = parseInt(vadeAraligi, 10); 
      const kayitIsmi = kisiTuru === 'Firma' ? firmaSahis : adSoyad;

      if (cariTipi === 'Müşteri' && borcNum > 0) {
        
        const batch = writeBatch(db);
        const taksitlerCollectionRef = collection(db, 'taksitler');
        
        // --- 1. PEŞİNAT KAYDI ---
        if (pesinatNum > 0) {
            const pesinatRef = doc(taksitlerCollectionRef);
            batch.set(pesinatRef, {
                cariId: cariId,
                cariAd: kayitIsmi,
                odemeGunu: new Date(satisTarihi),
                miktar: pesinatNum,
                durum: pesinatOdenmis ? 'Ödendi' : 'Bekliyor',
                odemeTarihi: pesinatOdenmis ? serverTimestamp() : null,
                ekBorcNotu: 'Peşinat Ödemesi'
            });
        }

        const kalanBorc = borcNum - pesinatNum;

        // --- 2. TAKSİTLENDİRME (OTOMATİK veya MANUEL) ---
        if (kalanBorc > 0) {
            
            if (planTuru === 'otomatik') {
                // --- A. OTOMATİK PLAN ---
                if (taksitNum > 0) {
                    const aylikMiktar = kalanBorc / taksitNum;
                    const startDate = new Date(satisTarihi);

                    for (let i = 1; i <= taksitNum; i++) {
                        const odemeGunu = new Date(startDate);
                        odemeGunu.setMonth(startDate.getMonth() + (i * aralikNum));
                        
                        const newTaksitRef = doc(taksitlerCollectionRef);
                        batch.set(newTaksitRef, {
                            cariId: cariId, cariAd: kayitIsmi,
                            odemeGunu: odemeGunu, miktar: aylikMiktar,
                            durum: 'Bekliyor'
                        });
                    }
                } else {
                    // Tek Kalem Kalan
                     const kalanRef = doc(taksitlerCollectionRef);
                     const vadeTarihi = new Date(satisTarihi);
                     vadeTarihi.setMonth(vadeTarihi.getMonth() + 1);
                     batch.set(kalanRef, {
                         cariId: cariId, cariAd: kayitIsmi,
                         odemeGunu: vadeTarihi, miktar: kalanBorc,
                         durum: 'Bekliyor', ekBorcNotu: 'Kalan Bakiye'
                     });
                }
            } 
            else if (planTuru === 'manuel') {
                // --- B. MANUEL PLAN ---
                if (manuelPlan.length === 0) throw new Error("Lütfen 'Listeyi Oluştur' butonuna basarak planı hazırlayın.");

                manuelPlan.forEach(satir => {
                    const ref = doc(taksitlerCollectionRef);
                    batch.set(ref, {
                        cariId: cariId, cariAd: kayitIsmi,
                        odemeGunu: new Date(satir.tarih),
                        miktar: parseFloat(satir.tutar),
                        durum: 'Bekliyor',
                        ekBorcNotu: 'Manuel Plan'
                    });
                });
            }
        }

        await batch.commit();
      }

      const userEmail = auth.currentUser ? auth.currentUser.email : "Bilinmeyen";
      logIslem("Yeni Kayıt", `${kisiTuru} eklendi: ${kisiTuru==='Firma'?firmaSahis:adSoyad} (Toplam: ${borcNum}₺)`, userEmail, cariId, 'cariler');

      setLoading(false);
      navigate('/admin/dashboard'); 

    } catch (err) {
      console.error("Hata:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1 className="brand-logo admin-brand-header" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }} title="Admin Paneline Dön">
          <img src="/logo.png" width="50" alt="" />
          ARAS ASAF İNŞAAT – YENİ CARİ
        </h1>
        <button onClick={() => navigate('/admin/dashboard')} className="admin-button-secondary small">İptal / Geri Dön</button>
      </div>

      <form className="yeni-cari-form" onSubmit={handleSubmit}>
        
        {/* KİŞİ BİLGİLERİ */}
        <div className="form-section">
          <h2 style={{borderBottom:'none', marginBottom:'10px'}}>Cari Tipi & Kişi Türü</h2>
          <div style={{ display: 'flex', gap: '15px', marginBottom: '10px' }}>
            <button type="button" onClick={() => setCariTipi('Müşteri')} style={{ flex: 1, padding: '15px', borderRadius: '8px', border: cariTipi==='Müşteri'?'2px solid #28a745':'1px solid #ddd', backgroundColor: cariTipi==='Müşteri'?'#28a745':'#fff', color: cariTipi==='Müşteri'?'#fff':'#555', fontWeight:'bold', cursor:'pointer' }}>👥 Müşteri (Alacaklı)</button>
            <button type="button" onClick={() => setCariTipi('Tedarikçi')} style={{ flex: 1, padding: '15px', borderRadius: '8px', border: cariTipi==='Tedarikçi'?'2px solid #dc3545':'1px solid #ddd', backgroundColor: cariTipi==='Tedarikçi'?'#dc3545':'#fff', color: cariTipi==='Tedarikçi'?'#fff':'#555', fontWeight:'bold', cursor:'pointer' }}>🚚 Tedarikçi (Borçlu)</button>
          </div>
          <div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
            <button type="button" onClick={() => setKisiTuru('Sahis')} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: kisiTuru==='Sahis'?'2px solid #007bff':'1px solid #ddd', backgroundColor: kisiTuru==='Sahis'?'#e7f1ff':'#fff', color: kisiTuru==='Sahis'?'#0056b3':'#555', fontWeight:'bold', cursor:'pointer' }}>👤 Şahıs</button>
            <button type="button" onClick={() => setKisiTuru('Firma')} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: kisiTuru==='Firma'?'2px solid #6610f2':'1px solid #ddd', backgroundColor: kisiTuru==='Firma'?'#f3e5ff':'#fff', color: kisiTuru==='Firma'?'#4800a8':'#555', fontWeight:'bold', cursor:'pointer' }}>🏢 Firma</button>
          </div>
          <div className="form-grid">
             {kisiTuru === 'Sahis' && (<><div className="form-group"><label>ADI SOYADI *</label><input type="text" value={adSoyad} onChange={(e) => setAdSoyad(e.target.value)} /></div><div className="form-group"><label>TC KİMLİK</label><input type="text" value={tc} onChange={(e) => setTc(e.target.value)} /></div></>)}
             {kisiTuru === 'Firma' && (<><div className="form-group"><label>FİRMA ÜNVANI *</label><input type="text" value={firmaSahis} onChange={(e) => setFirmaSahis(e.target.value)} /></div><div className="form-group"><label>VERGİ NO</label><input type="text" value={tc} onChange={(e) => setTc(e.target.value)} /></div><div className="form-group"><label>YETKİLİ KİŞİ</label><input type="text" value={adSoyad} onChange={(e) => setAdSoyad(e.target.value)} /></div></>)}
            <div className="form-group"><label>TELEFON *</label><input type="text" value={telefon} onChange={(e) => setTelefon(e.target.value)} /></div>
            <div className="form-group full-width"><label>ADRES</label><textarea rows="2" value={adres} onChange={(e) => setAdres(e.target.value)}></textarea></div>
          </div>
        </div>

        {/* --- ÖDEME PLANI --- */}
        {cariTipi === 'Müşteri' && (
          <div className="form-section" style={{ borderLeft: '5px solid #28a745' }}>
            <h2 style={{ color: '#28a745' }}>Ödeme Planı Oluştur</h2>
            
            {/* PLAN TÜRÜ SEÇİMİ */}
            <div style={{marginBottom:'20px', display:'flex', gap:'10px'}}>
                <button type="button" onClick={() => setPlanTuru('otomatik')} style={{padding:'8px 15px', borderRadius:'20px', border:'1px solid #28a745', backgroundColor: planTuru==='otomatik'?'#28a745':'#fff', color: planTuru==='otomatik'?'#fff':'#28a745', cursor:'pointer', fontWeight:'bold'}}>🤖 Otomatik Hesapla</button>
                <button type="button" onClick={() => setPlanTuru('manuel')} style={{padding:'8px 15px', borderRadius:'20px', border:'1px solid #ffc107', backgroundColor: planTuru==='manuel'?'#ffc107':'#fff', color: planTuru==='manuel'?'#000':'#d39e00', cursor:'pointer', fontWeight:'bold'}}>📝 Manuel (Elle) Düzenle</button>
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>TOPLAM SATIŞ BEDELİ</label>
                <CurrencyInput value={toplamBorc} onChange={setToplamBorc} placeholder="Örn: 3000000" />
              </div>
              
              <div className="form-group">
                <label>PEŞİNAT (ÖN ÖDEME)</label>
                <CurrencyInput value={pesinat} onChange={setPesinat} placeholder="Örn: 1000000" style={{borderColor: '#ffc107'}}/>
                <label style={{fontSize:'0.85rem', color:'#555', display:'flex', alignItems:'center', marginTop:'5px', cursor:'pointer'}}>
                    <input type="checkbox" checked={pesinatOdenmis} onChange={(e) => setPesinatOdenmis(e.target.checked)} style={{width:'16px', height:'16px', marginRight:'5px'}}/>
                    Peşinat Tahsil Edildi Olarak İşle
                </label>
              </div>

              <div className="form-group">
                <label>TAKSİT SAYISI (KALAN İÇİN)</label>
                <select value={taksitSayisi} onChange={(e) => setTaksitSayisi(e.target.value)}>
                  <option value="0">Taksit Yok</option>
                  {taksitOptions.map(ay => (<option key={ay} value={ay}>{ay} Taksit</option>))}
                </select>
              </div>

              {/* SADECE OTOMATİKTE GÖRÜNSÜN */}
              {planTuru === 'otomatik' && (
                  <div className="form-group">
                    <label>ÖDEME SIKLIĞI (VADE)</label>
                    <select value={vadeAraligi} onChange={(e) => setVadeAraligi(e.target.value)} style={{ border: '2px solid #28a745', fontWeight:'bold' }} disabled={taksitSayisi === '0'}>
                      <option value="1">Her Ay</option><option value="2">2 Ayda Bir</option><option value="3">3 Ayda Bir</option><option value="6">6 Ayda Bir</option><option value="12">Yılda Bir</option>
                    </select>
                  </div>
              )}

              <div className="form-group">
                <label>SATIŞ / BAŞLANGIÇ TARİHİ</label>
                <input type="date" value={satisTarihi} onChange={(e) => setSatisTarihi(e.target.value)} />
              </div>

              {/* --- MANUEL BUTONU --- */}
              {planTuru === 'manuel' && parseInt(taksitSayisi) > 0 && (
                  <div className="form-group" style={{alignSelf:'flex-end'}}>
                      <button type="button" onClick={planTaslagiOlustur} className="admin-button-secondary" style={{width:'100%'}}>📝 Listeyi Oluştur</button>
                  </div>
              )}
            </div>

            {/* MANUEL TABLO */}
            {planTuru === 'manuel' && manuelPlan.length > 0 && (
                <div style={{background:'#fff8e1', padding:'15px', borderRadius:'8px', marginTop:'15px'}}>
                    <table className="admin-table" style={{marginBottom:'10px'}}>
                        <thead><tr><th>Taksit</th><th>Tarih</th><th>Tutar (TL)</th></tr></thead>
                        <tbody>
                            {manuelPlan.map((satir, index) => (
                                <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td><input type="date" value={satir.tarih} onChange={(e) => updateManuelSatir(index, 'tarih', e.target.value)} style={{padding:'5px'}}/></td>
                                    <td><CurrencyInput value={satir.tutar} onChange={(val) => updateManuelSatir(index, 'tutar', val)} style={{padding:'5px', width:'100%', fontWeight:'bold', color:'#d39e00'}}/></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{textAlign:'right', fontWeight:'bold', color: Math.abs(hedefTaksitToplami - hesaplananManuelToplam) > 1 ? 'red' : 'green'}}>
                        Plan Toplamı: {formatCurrency(hesaplananManuelToplam)} (Hedef: {formatCurrency(hedefTaksitToplami)})
                    </div>
                </div>
            )}

            {/* BİLGİ NOTU (OTOMATİK) */}
            {planTuru === 'otomatik' && parseFloat(toplamBorc) > 0 && (
                <div className="form-group full-width" style={{background:'#e9ecef', padding:'10px', borderRadius:'5px', fontSize:'0.9rem', marginTop:'15px'}}>
                    <strong>Otomatik Plan Özeti:</strong> <br/>
                    Toplam: {parseFloat(toplamBorc).toLocaleString('tr-TR')} ₺ | Peşinat: {parseFloat(pesinat || 0).toLocaleString('tr-TR')} ₺ <br/>
                    <strong>Kalan: {(parseFloat(toplamBorc) - (parseFloat(pesinat)||0)).toLocaleString('tr-TR')} ₺</strong>
                    {parseInt(taksitSayisi) > 0 && (<span> ({taksitSayisi} x {((parseFloat(toplamBorc) - (parseFloat(pesinat)||0)) / parseInt(taksitSayisi)).toLocaleString('tr-TR', {maximumFractionDigits:2})} ₺)</span>)}
                </div>
            )}
          </div>
        )}
        
        {error && <p className="login-error" style={{marginTop: '20px'}}>{error}</p>}
        
        <div className="form-actions">
          <button type="submit" className="admin-button" disabled={loading} style={{ padding: '15px 40px', fontSize: '1.1rem' }}>
            {loading ? 'Kaydediliyor...' : '💾 Cariyi Kaydet'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default YeniCari;